import Cookies from 'js-cookie'
import allLanguageCodes from '~/tools/localization/languageCodes'
import { getToken } from "~/redux/user/tokens";
import jwtDecode from 'jwt-decode'

//This function is used to scan the entire modules array and locate all video Ids currently on the page
export function getVideoIdsFromPayload(modules) {
  const ids = [];

  function getIdFromObjectIfVideo(obj) {
    if (Array.isArray(obj)) {
      obj.forEach(getIdFromObjectIfVideo);
    }
    else if (typeof obj === 'object' && obj != null) {
      Object.keys(obj).forEach(key => {
        if (key === 'contentType' && obj[key] === "VIDEO") {
          ids.push(obj['id']);
        }
        getIdFromObjectIfVideo(obj[key]);
      })
    }
  }

  getIdFromObjectIfVideo(modules);

  return ids;
}

//This function is used to scan the modules array and locate the series ID if it is a show page.
export function getSeriesIdFromPayload(content) {

  let seriesId;

  if (content.title === 'Show Page') {
    content.modules.forEach(module => {
      if (module.moduleType === "ShowDetailModule" && module.contentData) {
        seriesId = module.contentData[0].id;
      }
    })
  }

  return seriesId;
}


//convert history array to object
export function formatHistory(history) {
  const fh = {};
  history.forEach((datum) => {
    fh[datum.videoId] = {
      watchedPercentage: datum.watchedPercentage,
      watchedTime: datum.watchedTime,
      latestEpisode: datum.latestEpisode
    };
  });
  return fh;
}

//This function takes in an object pairing videos Ids to watchTime and adds this field to relevant fields in the payload.
//Very general and not optimized
export function addWatchHistoryToPayload(historyPairs, obj) {

  if (Array.isArray(obj)) {
    obj.forEach((o) => addWatchHistoryToPayload(historyPairs, o));
  }
  else if (typeof obj === 'object' && obj != null) {
    Object.keys(obj).forEach(key => {
      if (key === 'contentType' && obj[key] === "VIDEO" && historyPairs[obj.id] !== undefined) {
        obj.watchHistory = historyPairs[obj.id];
      }
      addWatchHistoryToPayload(historyPairs, obj[key]);
    })
  }

}

//Add episode numbers and season title to payload if on a show page. Also a hack, want this info from pages API.
export function addEpisodeNumbersToPayload(content) {

  if (content.title === 'Show Page') {
    content.modules.forEach(module => {
      if (module.moduleType === "ShowDetailModule" && module.contentData) {
        const seasons = module.contentData[0].seasons;
        seasons.forEach((season, n) => {
          season.episodes.forEach((episode, i) => {
            episode.gist = {
              ...episode.gist,
              seasonTitle: season.title,
              seasonNumber: n,
              episodeNumber: i + 1
            };
          });
        });
      }
    })
  }

}

//Fetch user's current country code and corresponding language code 
export const fetchCurrentLanguage = async (languageCode = null, country) => {
  let overriddenCode = ''
  let selectedCode = ''
  if(!country) {
    const token = await getToken()
    var decodedToken = jwtDecode(token);
    country = decodedToken.countryCode
  }
  
  if (Cookies.get('userLanguageTrigger') !== "true" && !languageCode) {
    let countryCode = country;
    countryCode = countryCode && countryCode.toLowerCase()
    selectedCode = allLanguageCodes[countryCode]
    const languages = window.settings.languages && window.settings.languages.languages;
    if (languages) {
      const matchedCode = languages.find((langCode) => langCode.code === selectedCode);
      if (matchedCode) {
        overriddenCode = matchedCode.code
        Cookies.set('userLanguageSelection', overriddenCode)
        Cookies.set('userLanguageTrigger', false)
        Cookies.set('userCountrySelection', countryCode)
      }
    }

    return overriddenCode;
  }
  return languageCode
}